import React from 'react';

const orgServices = {};
export default React.createContext(orgServices);
